import React, { useEffect, useState } from 'react';
import { withStyles, Paper, CircularProgress } from '@material-ui/core';
import PresetForm from './FormPreset'
import { parseURL, objectDeepClean } from '../../../../sc-utilities';
import { snackActions } from '../../../../sc-utilities/SnackBar';
import { CancelToken } from 'axios';
import { connect } from "react-redux";
import * as actions from '../store/projectActions'

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '5px',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
    logo: {
        width: '250px',
        margin: '10px'
    }
});

let securazeInitialValues = {
    PresetsEnabled: false,
    AutoEnableRemoteAccess: true,
    AutoShutdown: true,
    AutoStartErasure: false,
    NormalScreenBrightness: 80,
    ReducedScreenBrightness: 30,
    ErasureSSD: {
        Method: 'securaze_ssd_performance',
        Verification: {
            Method: 'last',
            CustomValue: 10
        }
    },
    ErasureHDD: {
        Method: 'securaze_ssd_performance',
        Verification: {
            Method: 'last',
            CustomValue: 10
        }
    },
    ErasureMobile: {
        Type: 'full',
        Method: 'securaze_ssd',
        Verification: {
            Method: 'last',
            CustomValue: 10
        }
    },
    AutoStartDiagnose: false,
    AutoPrint: false
}

const ProjectPresets = props => {
    const { classes, updatePresets, project, onFetchErasureMethods, fetchOrders, loading, setLoading, translations, fetchCollies, fetchGrades, fetchPrinters, fetchOperatingSystems, activeCustomer, loadProject } = props;
    const presets = project && project.Presets && Object.keys(project.Presets).length > 1 ? JSON.parse(project.Presets) : null;
    let searchParams = parseURL(window.location.search);
    const presetsCancel = CancelToken?.source();
    const [presetFilter, setPresetsFilter] = useState({ orders: [], grades: [], printers: [], Collies: [], operatingSystems: [], methods: [], loading: true });

    const ordersCancel = CancelToken?.source();
    const colliesCancel = CancelToken?.source();
    const gradesCancel = CancelToken.source();
    const printersCancel = CancelToken.source();
    const osCancel = CancelToken.source();
    const requestToken = CancelToken.source();


    const collectPresets = (data) => {
        let presetData = {
            PresetsEnabled: !!data?.PresetsEnabled,
            AutoEnableRemoteAccess: !!data?.AutoEnableRemoteAccess,
            AutoPrint: !!data?.AutoPrint,
            AutoShutdown: !!data?.AutoShutdown,
            AutoStartErasure: !!data?.AutoStartErasure,
            AutoStartDiagnose: !!data?.AutoStartDiagnose,
            OrderID: data?.OrderID,
            TransportColliID: data?.TransportColliID,
            ColliID: data?.ColliID,
            ErasureSSD: {
                Method: data?.MethodSSD,
                Verification: {
                    Method: data?.VerificationSSD,
                    CustomValue: data?.CustomValueSSD
                }
            },
            ErasureHDD: {
                Method: data?.MethodHDD,
                Verification: {
                    Method: data?.VerificationHDD,
                    CustomValue: data?.CustomValueHDD
                }
            },
            ErasureMobile: {
                Type: data.TypeMobile,
                Method: data.MethodMobile,
                Verification: {
                    Method: data.VerificationMobile,
                    CustomValue: data.CustomValueMobile
                }
            },
            PrinterID: data.PrinterID,
            GradeID: `${data.GradeID}`,
            OperatingSystemID: `${data.OperatingSystemID}`,
            // DiagnoseWorkplace: {
            // },
            // DiagnoseMobile: {
            // }
        }
        return presetData;
    }

    const handleEnableDisableAction = async (data) => {
        let CustomerID = project.CustomerID + '';
        let serverResult = await updatePresets({ Presets: {}, UpdateOnlyPresetEnabled: true, PresetsEnabled: data.PresetsEnabled, CustomerID: CustomerID, ActiveCustomerID: activeCustomer }, { cancelToken: presetsCancel });
        serverResult && setLoading(false);
        if (serverResult.status) {
            return snackActions.snackBarComponent("Presets updated.", "success");
        } else {
            return snackActions.snackBarComponent("Error: Failed to update presets", "error");
        }
    };

    useEffect(() => {

        const fetchData = async () => {
            await loadProject({ ActiveCustomerID: activeCustomer, ProjectID: parseURL(window.location.href).projectID }, { cancelToken: requestToken.token })
            let methods = await onFetchErasureMethods({ ActiveCustomerID: activeCustomer })
            let orderData = await fetchOrders({ ActiveCustomerID: activeCustomer, ProjectID: searchParams.productID }, { cancelToken: ordersCancel });
            let collies = await fetchCollies({ ActiveCustomerID: activeCustomer, ProjectID: searchParams.productID }, { cancelToken: colliesCancel });
            let grades = await fetchGrades({ ActiveCustomerID: activeCustomer, ProjectID: searchParams.productID }, { cancelToken: gradesCancel });
            let printers = await fetchPrinters({ ActiveCustomerID: activeCustomer, ProjectID: searchParams.productID }, { cancelToken: printersCancel });
            let operatingSystems = await fetchOperatingSystems({ ActiveCustomerID: activeCustomer, ProjectID: searchParams.productID }, { cancelToken: osCancel });

            if (orderData && collies && grades && printers && operatingSystems && methods) {
                setPresetsFilter({ methods: methods, loading: false, orders: orderData, Collies: collies, printers: printers, grades: grades, operatingSystems: operatingSystems })
            }
        }
        fetchData()
        return () => {
            ordersCancel.cancel('Operation canceled by the user.');
            colliesCancel.cancel('Operation canceled by the user.');
            gradesCancel.cancel('Operation canceled by the user.');
            printersCancel.cancel('Operation canceled by the user.');
            osCancel.cancel('Operation canceled by the user.');
            requestToken.cancel('Operation canceled by the user.');
            presetsCancel.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomer]);


    let initialValuesPreset = {
        PresetsEnabled: presets ? !!presets?.PresetsEnabled : securazeInitialValues.PresetsEnabled,
        AutoShutdown: presets ? !!presets?.AutoShutdown : securazeInitialValues.AutoShutdown,
        OrderID: presets?.OrderID || '',
        TransportColliID: presets?.TransportColliID || '',
        ColliID: presets?.ColliID || "",
        AutoStartErasure: presets ? !!presets?.AutoStartErasure : securazeInitialValues.AutoStartErasure,
        AutoEnableRemoteAccess: presets ? !!presets?.AutoEnableRemoteAccess : securazeInitialValues.AutoEnableRemoteAccess,
        MethodSSD: presets?.ErasureSSD?.Method || "securaze_ssd_performance",
        VerificationSSD: presets?.ErasureSSD?.Verification?.Method || 'last',
        CustomValueSSD: presets?.ErasureSSD?.Verification?.CustomValue || 10,
        MethodHDD: presets?.ErasureHDD?.Method || 'securaze_ssd_performance',
        VerificationHDD: presets?.ErasureHDD?.Verification?.Method || 'last',
        CustomValueHDD: presets?.ErasureHDD?.Verification?.CustomValue || 10,
        TypeMobile: presets?.ErasureMobile?.Type || "full",
        MethodMobile: presets?.ErasureMobile?.Method || "securaze_ssd",
        VerificationMobile: presets?.ErasureMobile?.Verification?.Method || 'last',
        CustomValueMobile: presets?.ErasureMobile?.Verification?.CustomValue || 10,
        PrinterID: presets?.PrinterID || '',
        GradeID: presets?.GradeID || '',
        OperatingSystemID: presets?.OperatingSystemID || '',
        AutoStartDiagnose: presets ? !!presets?.AutoStartDiagnose : securazeInitialValues.AutoStartDiagnose,
        AutoPrint: presets ? !!presets?.AutoPrint : securazeInitialValues.AutoPrint,
        NormalScreenBrightness: presets?.NormalScreenBrightness ?? 100,
        ReducedScreenBrightness: presets?.ReducedScreenBrightness ?? 80,
    };

    let formSettingsPreset = {
        Validation: {
        },
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        }
    };

    const handleSubmit = async data => {
        const presets = collectPresets(data);
        let serverResult = await updatePresets({ Presets: objectDeepClean(presets), ProjectID: project.ProjectID, ActiveCustomerID: activeCustomer });

        if (serverResult.status) {
            return snackActions.snackBarComponent(translations['update_presets'] || "Presets updated.", "success");
        } else {
            return snackActions.snackBarComponent(translations['failed_to_update_presets'] || "Error: Failed to update presets", "error");
        }
    };

    return (
        <Paper className={classes.root} >

            {!loading && !presetFilter.loading ?
                <PresetForm
                    formSettings={formSettingsPreset}
                    initialValues={initialValuesPreset}
                    customerID={searchParams.customerID}
                    activeCustomer={activeCustomer}
                    handleSubmit={handleSubmit}
                    loadProject={loadProject}
                    translations={translations}
                    methods={presetFilter.methods}
                    setLoading={setLoading}
                    customerPresetFilter={{ operatingSystems: presetFilter.operatingSystems, grades: presetFilter.grades, printers: presetFilter.printers, orders: presetFilter.orders, collies: presetFilter.Collies }}
                    handleEnableDisableAction={handleEnableDisableAction}
                    project={project}
                    updatePresets={updatePresets}
                    securazeInitialValues={securazeInitialValues}
                ></PresetForm>
                : <CircularProgress />}
        </Paper>
    )
};
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchOrders: (id, options) => dispatch(actions.fetchOrders(id, options)),
        fetchCollies: (id, options) => dispatch(actions.fetchCollies(id, options)),
        fetchPrinters: (id, options) => dispatch(actions.fetchPrinters(id, options)),
        fetchGrades: (id, options) => dispatch(actions.fetchGrades(id, options)),
        onFetchErasureMethods: (user) => (dispatch(actions.fetchErasureMethod(user))),
        updatePresets: (params, options) => dispatch(actions.updatePresets(params, options)),
        loadProject: (data, options) => dispatch(actions.loadProject(data, options)),
        fetchOperatingSystems: (params, options) => dispatch(actions.fetchOperatingSystems(params, options))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ProjectPresets));

